// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title--mS3Yz{padding-top:40px;padding-bottom:40px}.title--mS3Yz+.contentful-component{padding-top:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "title--mS3Yz"
};
export default ___CSS_LOADER_EXPORT___;
